import { Component, HostListener, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { RiskLevel } from './core/models/fna';
import { ComponentInstanceService } from './core/services/component-instance.service';
import { GlobalsService } from './core/services/globals.service';
import { SideBar, SideBarService } from './core/services/side-bar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [NgbModalConfig, NgbModal],
})
export class AppComponent {
  title = 'OCBC FNA';
  _windowInnerWidth = 0;

  get windowInnerWidth() {
    return this._windowInnerWidth;
  }

  set windowInnerWidth(width: number) {
    this._windowInnerWidth = width;
    this.globals.isMobile = this.windowInnerWidth < 992;
    this.globals.isLessThan1200Width = this.windowInnerWidth < 1200;
  }

  constructor(
    public globals: GlobalsService,
    private router: Router,
    private activeRoute:ActivatedRoute,
    private sideBarService: SideBarService,
    private componentInstanceService: ComponentInstanceService,
    private renderer: Renderer2,
    private modalConfig: NgbModalConfig,
  ) {
    modalConfig.centered = true;
    // modalConfig.scrollable = true;
    modalConfig.size = 'lg';
    modalConfig.modalDialogClass = 'fna-modal-dialog';
    modalConfig.backdropClass = 'fna-modal-backdrop';
  }

  ngOnInit() {
    // Scroll to top after navigation.
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }

      this.enableBodyScroll();
      window.scrollTo(0, 0);
    });

    this.activeRoute.queryParamMap.subscribe((params)=>{
      let paramObject ={...params.keys, ...params};
      console.log("PARAMA OBJECTS");
      console.log(params);
    });

    this.windowInnerWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.windowInnerWidth = event.target.innerWidth;
  }

  // @HostListener('document:keydown', ['$event']) onKeydownHandler(
  //   event: KeyboardEvent,
  // ) {
  //   if (event.altKey && event.code === 'KeyF') {
  //     this.fillFormWithMockData();
  //   }
  // }

  get appWrapperClass() {
    const classes = [];
    if (this.sideBarService.sideBarState === SideBar.None) {
      classes.push('app--no-sidebar');
    }
    if (this.sideBarService.sideBarState === SideBar.Default) {
      classes.push('app--default-sidebar');
    }
    if (this.sideBarService.sideBarState === SideBar.Stepper) {
      classes.push('app--stepper-sidebar');
    }
    if (
      this.globals.isEnableSaveDraftFeature &&
      this.globals.model.LastSavedTime &&
      (this.sideBarService.sideBarState === SideBar.Default ||
        this.sideBarService.sideBarState === SideBar.Stepper)
    ) {
      if (this.globals.showLastTimeSavedMobile) {
        classes.push('app--has-last-saved');
      }
    }

    classes.push(this.globals.isMobile ? 'mobile' : 'desktop');

    // if (this.globals.appClass) {
    //   classes.push(this.globals.appClass);
    // }
    return classes.join(' ');
  }

  get hasSideBar() {
    return this.sideBarService.sideBarState !== SideBar.None;
  }

  onRouterOutletActivate(event: any) {
    this.componentInstanceService.current = event;
  }

  mockIsAccountLocked(isAccountLocked: boolean) {
    console.log('[mockIsAccountLocked]:', isAccountLocked);
    this.globals.mockedIsAccountLocked = isAccountLocked;
    this.refreshPage();
  }

  mockIsFirstTimeLogin(isFirstTimeLogin: boolean) {
    console.log('[mockIsFirstTimeLogin]:', isFirstTimeLogin);
    this.globals.mockedIsFirstTimeLogin = isFirstTimeLogin;
    this.refreshPage();
  }

  mockDeclaredRisk(risk: RiskLevel | null) {
    console.log('[mockDeclaredRisk]:', risk);
    this.globals.mockedDeclaredRisk = risk;
    this.refreshPage();
  }

  mockAssessedRisk(risk: RiskLevel | null) {
    console.log('[mockAssessedRisk]:', risk);
    this.globals.mockedAssessedRisk = risk;
    this.refreshPage();
  }

  mockAcceptAssessedRiskProfile(isAccept: boolean | null) {
    this.globals.mockIsAcceptAssessedRiskProfile = isAccept;
    this.refreshPage();
  }

  mockAcceptRecommendedProducts(isAccept: boolean | null) {
    this.globals.mockIsAcceptRecommendedProducts = isAccept;
    this.refreshPage();
  }

  mockIsPurchaseTableBProducts(isAccept: boolean | null) {
    this.globals.mockIsPurchaseTableBProducts = isAccept;
    this.refreshPage();
  }

  mockSimulateServerBehaviour(option: boolean) {
    this.globals.simulateServerBehaviour = option;
    this.refreshPage();
  }

  get riskLevel(): typeof RiskLevel {
    return RiskLevel;
  }

  refreshPage() {
    const currentUrl = this.router.url;
    console.log('currentUrl:', currentUrl);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([currentUrl]));
  }

  toggleDebug() {
    this.globals.isDebug = !this.globals.isDebug;
  }

  logDebugData() {
    this.globals.logModelForDebug();
  }

  get isFillFormAvailable() {
    const currentInstance = this.componentInstanceService.current;
    return (
      currentInstance &&
      typeof currentInstance.fillFormWithMockData == 'function'
    );
  }

  fillFormWithMockData() {
    if (!this.isFillFormAvailable) {
      return;
    }

    this.componentInstanceService.current.fillFormWithMockData();
  }

  enableBodyScroll() {
    // console.log('Enabling body scrolling in app component.');
    this.renderer.removeClass(document.body, 'no-scroll');
  }

  get isLoading() {
    return this.globals.isLoading;
  }
}
